<template>
  <div class="subtitle-export">
    <div class="main">
      <div class="header">
        <div class="title">设置导出信息</div>
        <div class="row">
          <div
            class="close-btn"
            @click="close"
          ></div>
        </div>
      </div>
      <div class="content">
        <Cover
          v-model="cover"
          :isFirstFrameCover="isFirstFrameCover"
          @toggleFirstFrameCover="toggleFirstFrameCover"
          ref="Cover"
        />
        <div
          class="field-wrapper"
          style="margin-top: 40px;"
        >
          <TitleField v-model="title" />
        </div>
        <TagsField v-model="tags" />
        <IntroField v-model="description" />
        <div
          class="field-wrapper"
          style="margin-top: 40px;"
        >
          <WatermarkField />
        </div>
        <div
          class="submit-btn"
          @click="submit"
        >确定</div>
        <div
          v-if="typeof initialChecked === 'boolean'"
          style="padding-bottom: 30px;"
        >
          <checkbox-share
            ref="checkboxShare"
            :initialChecked="initialChecked"
          ></checkbox-share>
        </div>
      </div>
    </div>

    <CoverCropper
      :visible="isShowCoverDialog"
      :coverType="'video'"
      @closeDialog="closeCoverCropper()"
      @confirm="customCoverConfirm()"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Cover from "./subtitleExport/cover";
import TitleField from "./subtitleExport/titleField";
import TagsField from "./subtitleExport/tagsField";
import IntroField from "./subtitleExport/introField";
import WatermarkField from "./subtitleExport/watermarkField";
import CoverCropper from "./subtitleExport/coverDialog";
import { exportVideo, uploadVideoCover } from "./subtitleApi";
import checkboxShare from "@/components/topnav/exportDialog/checkboxShare.vue";

export default {
  components: {
    Cover,
    TitleField,
    TagsField,
    IntroField,
    WatermarkField,
    CoverCropper,
    checkboxShare
  },
  data () {
    return {
      // title: "",
      tags: "",
      description: "",
      cover: "",
      isFirstFrameCover: false,
      initialChecked: true,
    };
  },
  computed: {
    ...mapGetters([
      'UserLevel'
    ]),
    ...mapGetters({
      isShowCoverDialog: "subtitleExport/isShowCoverDialog",
      customCover: "subtitleExport/customCover",
      watermark: "subtitleExport/watermark",
      subtitleObj: "subtitle/subtitleObj",
      watermarkType: "subtitleExport/watermarkType",
      customWatermark: "subtitleExport/customWatermark",
    }),
    title: {
      get () {
        if (!this.subtitleObj) {
          return "";
        }
        return this.subtitleObj.title;
      },
      set (val) { },
    },
    fileType () {
      return (this.$route.fileType || this.$route.filetype) - 0;
    }
  },
  watch: {
    UserMsg (val) {
      this.initialChecked = this.getShareState();
    }
  },
  methods: {
    close () {
      this.$store.commit("subtitleExport/showExport", false);
    },
    closeCoverCropper () { },
    customCoverConfirm (coverPic) {
      this.$store.commit("subtitleExport/setCustomCover", coverPic);
      // this.$refs.Cover.items[3] = coverPic;
    },
    async submit () {
      let exportParam = this.getExportParam();
      if (!exportParam) {
        return;
      }

      //1.上传封面
      if (this.cover) {
        let formData = new FormData();
        formData.append("imageName", this.cover);
        let coverInfo = await uploadVideoCover(formData);

        if (coverInfo) {
          exportParam.screen = coverInfo.filename;
          exportParam.thumbnailUrl = coverInfo.thumbnailName;
          if (this.isFirstFrameCover) {
            let data = JSON.parse(exportParam.data);
            data.cover = coverInfo.filename;
            exportParam.data = JSON.stringify(data);
          }
        }
      }

      //2.导出
      let res = await exportVideo(exportParam);
      //console.log("导出",exportParam.data, res);
      if (res && res.type === 'error') {
        this.$message({
          showClose: false,
          message: (res.payload || {}).msg || '视频导出失败!',
          type: "error",
          center: true,
        });
      } else {
        let path = this.fileType === 49 ? '/workplace/dashboard/creator/all/works' : '/workplace/dashboard/createProject';
        location.assign(path);
      }
    },
    convertBase64UrlToBlob (urlData) {
      var bytes = window.atob(urlData.split(",")[1]); //去掉url的头，并转换为byte

      //处理异常,将ascii码小于0的转换为大于0
      var ab = new ArrayBuffer(bytes.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i);
      }

      return new Blob([ab], { type: "image/png" });
    },

    getExportParam () {
      if (!this.checkExportParam()) {
        return null;
      }
      let exportParam = {
        title: this.title,
        times: this.subtitleObj.duration,
        videoId: this.subtitleObj.id,
        watermark: this.watermark,
        resolution: this.subtitleObj.resolution.height,
        optimized: "Horizontal",
        direction: 0,
        data: this.getJsonData(),
        shareToSquare: this.$refs.checkboxShare
          ? this.$refs.checkboxShare.getCheckedNum()
          : 1,
      };
      let fileType = (this.$route.fileType || this.$route.filetype) - 0;
      if (fileType === 49) {
        exportParam.fileType = fileType;
      }
      exportParam.caption = JSON.stringify(this.subtitleObj);
      if (this.tags) {
        exportParam.tags = this.tags;
      }
      if (this.description) {
        exportParam.description = this.description;
      }
      if (this.watermark === 'default') {
        exportParam.watermark = 'watermark/video-watermark.png';
      }
      if (this.watermark === 'custom') {
        exportParam.watermark = this.customWatermark.url;
      }
      return exportParam;
    },
    getJsonData () {
      let fileType = this.$route.fileType || this.$route.filetype;
      fileType -= 0;
      let duration = this.subtitleObj.duration;
      let coordinate = this.subtitleObj.coordinate;
      let data = {
        id: "",
        title: this.subtitleObj.title,
        duration: duration,
        sound: [],
        scenes: [
          {
            sceneId: "",
            index: 0,
            sound: [],
            duration: duration,
            background: {
              color: "#ffffff",
              type: "Color",
              fileType: null,
              opacity: 1,
              blur: 0,
            },
            sprites: [
              {
                url: this.subtitleObj.url,
                startTime: 0,
                isLoop: false,
                videoStartTime: 0,
                videoDuration: duration,
                volume: 50,
                resourceId: this.subtitleObj.id,
                zIndex: 1,
                type: "Video",
                fileType,
                outward: {
                  x: coordinate.x,
                  y: coordinate.y,
                  width: coordinate.width,
                  height: coordinate.height,
                  rotation: 0,
                  opacity: 1,
                  isFlipped: false,
                },
                enterEffect: {
                  type: "None",
                  duration: 0,
                },
                stayEffect: {
                  type: "None",
                  duration: duration,
                },
                exitEffect: {
                  type: "None",
                  duration: 0,
                },
              },
            ],
            enterEffect: {
              type: "None",
              duration: 0,
            },
            exitEffect: {
              type: "None",
              duration: 0,
            },
            resolution: {
              width: 1920,
              height: 1080,
            },
          },
        ],
        resolution: {
          width: 1920,
          height: 1080,
        },
        productionPlatform: "Web",
        targetPlatform: "App",
        version: "5.1",
      };

      if (this.watermarkType === "default") {
        let info = {
          url: "watermark/video-watermark.png",
          resolution: 1080,
          x: 0,
          y: 0,
          w: 0,
          h: 0,
          angle: 0,
        };
        // 500*178 水印的宽高
        let rateW = 500 / 178;
        let rate = coordinate.width / coordinate.height;
        if (rate >= 1) {
          info.h = coordinate.height * 0.2;
          info.w = info.h * rateW;
        } else {
          info.w = coordinate.width * 0.4;
          info.h = info.w / rateW;
        }
        info.y = coordinate.height - info.h / 2 + coordinate.y;
        info.x = coordinate.width - info.w / 2 + coordinate.x;
        data.watermarkInfo = info;
      }

      if (this.watermarkType === "custom") {
        this.$refs.Cover.sendInfoToEngine();
        data.watermarkInfo = this.customWatermark;
      }

      data.subtitle = this.subtitleObj;
      return JSON.stringify(data);
    },
    checkExportParam () {
      if (!this.title) {
        return false;
      }
      return true;
    },
    toggleFirstFrameCover (flag) {
      this.isFirstFrameCover = flag;
    },
    getShareState () {
      let dict = this.$util.localStorage.get("userShares");
      let val = (dict || {})[this.UserMsg.id + ""] || "on";
      return !!(val === "on");
    },
    setShareState (val) {
      let dict = this.$util.localStorage.get("userShares");
      if (!dict) {
        dict = {};
      }
      dict[this.UserMsg.id] = val;
      this.$util.localStorage.set("userShares", dict);
    },
  }
};
</script>

<style lang="scss" scoped>
.subtitle-export {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1111;
  width: 100%;
  height: 100%;
  background-color: #fff;
  overflow: auto;
}
.main {
  width: 1200px;
  margin: auto;
}
.header {
  .title {
    width: 1200px;
    padding: 13px;
    font-size: 14px;
    color: #474261;
    border-bottom: 1px solid #eaeaf4;
  }
  .row {
    display: flex;
    justify-content: flex-end;
    padding: 16px 20px;
  }
  .close-btn {
    display: inline-block;
    width: 20px;
    height: 20px;
    background-image: url(../../../static/svg/close.svg);
    background-size: 100% 100%;
    cursor: pointer;
    &:hover {
      opacity: 0.6;
    }
  }
}

.content {
  width: 528px;
  margin: auto;
}
.submit-btn {
  width: 160px;
  height: 40px;
  background: #5778fb;
  border-radius: 4px;
  line-height: 40px;
  color: #fff;
  margin: auto;
  margin-top: 50px;
  margin-bottom: 25px;
  cursor: pointer;
  &:hover {
    background-color: #7d95f5;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/subtitle/subtitleExport.vue